import { useQuery } from '@apollo/client';
import { GET_CANDIDATE_QUERY } from '../queries/candidateQueries';

export const useCandidateData = (id, companyId) => {
  const { loading, error, data } = useQuery(GET_CANDIDATE_QUERY, {
    variables: { id, companyId },
    fetchPolicy: 'no-cache',
    skip: !companyId
  });

  const candidate = data?.getCandidate;

  return {
    loading,
    error,
    candidate
  };
};